import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlockType } from 'src/app/core/models/enums/blockType';
import { NotificationType } from 'src/app/core/models/enums/notificationType';
import { UserRoles } from 'src/app/core/models/enums/userRoles';
import { UserStatus } from 'src/app/core/models/enums/userStatus';
import { PagedInviteGridDto } from 'src/app/core/models/invite-grid-model';
import { Invite } from 'src/app/core/models/invite-model';
import { SystemAccountAuthModel } from 'src/app/core/models/system-account';
import { IAuthService } from 'src/app/core/services/api/contracts/auth-service';
import { Options } from 'src/app/shared/components/pagination/pagination.component';
import { TranslateService } from '@ngx-translate/core';
import { InviteService } from 'src/app/core/services/api/invite.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BasicModalOperationResult, DialogModalComponent, IBasicModalComponentInstance } from 'src/app/shared/components/dialog-modal/dialog-modal.component';
import { BlockUnblockService } from 'src/app/core/services/api/blockunblock.service';
import { GuardianProxyService } from 'src/app/core/services/api/guardian-proxy.service';
import { OutgoingChatMessageStatusEnum } from 'src/app/core/models/enums/IncomingChatMessageStatusEnum';

@Component({
  selector: 'app-users-by-organizations-grid',
  templateUrl: './users-by-organizations-grid.component.html',
  styleUrls: ['./users-by-organizations-grid.component.scss']
})
export class UsersByOrganizationsGridComponent implements OnInit {
  users: Invite[];
  usersGrid: PagedInviteGridDto = new PagedInviteGridDto();
  showSpinner: boolean = true;
  submitting: boolean = false;
  userRoles = UserRoles;
  userStatus = UserStatus;
  notificationType = NotificationType;
  blockUnblockType = BlockType;
  currentUser: SystemAccountAuthModel;  
  options: Options = {
    page: 1,
    size: 10
  };
  isVisible: boolean =false; 
  data: string;
  isUsersGrid: boolean = false;

  constructor(
    @Inject("IAuthService") private authService: IAuthService,
    private route: ActivatedRoute,
    private inviteService: InviteService,
    private modalService: NgbModal,
    public translate: TranslateService,
    private blockUnblockService: BlockUnblockService,
    private guardianProxyService: GuardianProxyService,
  ) { }

  async ngOnInit() {

    this.route.params.subscribe(params => {
      this.data = params['id'];
    });
   
    await this.loadData(this.options.page, this.options.size, this.data);
    this.currentUser = await this.authService.getCurrentProfile();
    this.showSpinner = false;
   
  }

  loadData = async (page?: number, itemsPerPage?: number, data?:any) => {
     this.usersGrid = await this.inviteService.getUsers(page, itemsPerPage, data, this.isUsersGrid);
     this.users = this.usersGrid.apiEnabledInvites.items;
     
  }

  convertDate(dateString: string) {
    var dateStringToBeConverted =
      dateString.replace(/-/g, "/").replace(/T/g, " ") + " UTC";
    let convertedDate = new Date(dateStringToBeConverted);
    return convertedDate;
  }

  async changeRoleUser(userInvite: Invite) {
 
    const modalInstance = this.modalService.open(DialogModalComponent)
      .componentInstance as IBasicModalComponentInstance;
    modalInstance.title = this.translate.instant("usersModule.changeRole");
    modalInstance.body = this.translate.instant("usersModule.userToChangeRole", {
        UserFullName: userInvite.fullName,
      });
    modalInstance.type = BasicModalOperationResult.Warning;

    modalInstance.buttons = [
      {
        text: this.translate.instant("cancel"),
        cssClass: "btn btn-danger",
        closeModalOnClick: true,
      },
      {
        text: this.translate.instant("confirm"),
        cssClass: "btn btn-success",
        closeModalOnClick: true,
        handler: async () => {
          try {
            this.showSpinner = true;
            this.submitting = true;
            let responseAmi = await this.inviteService.changeUserRoleAmi(userInvite);

            if(responseAmi == OutgoingChatMessageStatusEnum.CONFIRMED)
            {   
            this.changeRole(userInvite); 
            let response = await this.inviteService.changeUserRole(userInvite);
            if(response != null)
            {
            this.showSpinner = false;
            this.submitting = false;
            await this.showSuccessfulMessage(userInvite);
            this.showSpinner = true;
            await this.loadData(this.options.page, this.options.size, this.data);
            this.showSpinner = false;
            }            
            }
            else if (responseAmi == OutgoingChatMessageStatusEnum.ERROR){
            this.showSpinner = true;
            await this.loadData(this.options.page, this.options.size, this.data);
            this.showSpinner = false;
            }
            
          } catch (error) {
            alert(this.translate.instant("signatureErrorMessage"));
            this.showSpinner = false;
            this.submitting = false;            
          }
        },
      },
    ];
  }

  async showSuccessfulMessage(userInvite: Invite) {
    const modalRef = this.modalService.open(DialogModalComponent, {
      backdrop: "static",
      keyboard: false,
    });

    const modalInstance =
      modalRef.componentInstance as IBasicModalComponentInstance;
    modalInstance.body = this.translate.instant("usersModule.userToChangeRole", {
        UserFullName: userInvite.fullName,
      });
    
    modalInstance.title = this.translate.instant("userUpdated");
    modalInstance.type = BasicModalOperationResult.Success;

    await modalRef.result;
  }

  changeRole(userInvite: Invite){
    if(userInvite.role == 'Admin')
    {
      userInvite.role= "Operador";
    }
    else
    userInvite.role = 'Admin';
  }
  
}
